
import { Component, Prop, Vue } from "vue-property-decorator"

import { CaseColumn } from "@/types/caseColumns"

import { InsightCalculation } from "@/types/insights"
import DataSourceSelect from "../Fields/DataSourceSelect.vue"
import { TimeSpentCalculation } from "@/types/insights/calculation"

@Component({
	components: {
		"data-select": DataSourceSelect
	}
})
export default class TimeSpentCalculationInput extends Vue {
	@Prop()
	calculationField!: CaseColumn;

	@Prop()
	trackingField!: CaseColumn;

	@Prop()
	calculation!: InsightCalculation;

	get timeSpentCalculation () : TimeSpentCalculation {
		if (!this.calculation!.timeSpentCalculation) {
			return {
				trackingFieldId: this.trackingField.fieldId!,
				searchLabel: null,
				searchValue: null
			}
		}
		return this.calculation!.timeSpentCalculation!
	}

	mounted () {
		if (!this.calculation!.timeSpentCalculation) {
			const timeSpentValue = {
				trackingFieldId: this.trackingField.fieldId,
				searchLabel: null,
				searchValue: null
			}
			this.$emit("timeSpentCalculationChange", timeSpentValue)
		}
	}

	private timeSpentCalculationChange (newValue: any) {
		const timeSpentValue = {
			trackingFieldId: this.trackingField.fieldId,
			searchLabel: newValue.label,
			searchValue: newValue.id
		}
		this.$emit("timeSpentCalculationChange", timeSpentValue)
	}
}
